// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__Rib6N","content":"Header_content__PO40L","cell":"Header_cell__sp3oT","userNav":"Header_userNav__Lq6K6"};